import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Flex } from '@rebass/grid';
import Image from 'static/images/plate-with-knife-and-fork.png';

const Table = styled(Flex).attrs({
  alignItems: 'center',
  justifyContent: 'center',
})`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const Plate = styled.img.attrs({
  src: Image,
})`
  height: 300px;
  width: auto;
  animation: ${rotate360} 2s linear infinite;
`;

const Loading = () => (
  <Table>
    <Plate />
  </Table>
);

export default Loading;
